import type { SvgIconProps } from "@mui/material";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

interface Props {
  title: string;
  Icon: FC<SvgIconProps>;
}

const AppCard = ({ title, Icon, children }: PropsWithChildren<Props>) => (
  <Card variant="outlined" sx={{ width: "16rem", "& .MuiCardContent-root": { p: 1.5, ":last-child": { pb: 1.5 } } }}>
    <CardContent>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <Icon sx={{ width: 48, height: 48 }} />
        <Stack spacing={0.5}>
          <Typography variant="subtitle1" sx={{ pl: "5px" }}>
            {title}
          </Typography>
          <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            {children}
          </Stack>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);

export default AppCard;
